import $ from 'zepto';
import {
  UP_ARROW_KEYCODE,
  LEFT_ARROW_KEYCODE,
  RIGHT_ARROY_KEYYCODE,
  DOWN_ARROW_KEYCODE,
  ESC_KEYCODE,
  TAB_KEYCODE,
} from '../../../utils/constants';

const keys = [
  UP_ARROW_KEYCODE,
  LEFT_ARROW_KEYCODE,
  RIGHT_ARROY_KEYYCODE,
  DOWN_ARROW_KEYCODE,
  ESC_KEYCODE,
  TAB_KEYCODE,
];

let $popupLinks;
let hidePopupFn;
let $target;

function getItem(list, item, next) {
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < list.length; i++) {
    if (list[i] === item) {
      return next ? list[i + 1] : list[i - 1];
    }
  }
  return null;
}
function focusPrevItem($item) {
  const $prev = getItem($popupLinks, $item, false);
  if ($prev) {
    $prev.focus();
  }
}
function focusNextItem($item) {
  const $next = getItem($popupLinks, $item, true);
  if ($next) {
    $next.focus();
  }
}
function onKeyDownItem(evt) {
  if (keys.indexOf(evt.which) === -1) {
    return;
  }
  evt.preventDefault();
  evt.stopPropagation();

  const $item = evt.target;

  switch (evt.which) { // eslint-disable-line default-case
    case UP_ARROW_KEYCODE:
    case LEFT_ARROW_KEYCODE:
      focusPrevItem($item);
      break;
    case DOWN_ARROW_KEYCODE:
    case RIGHT_ARROY_KEYYCODE:
    case TAB_KEYCODE:
      focusNextItem($item);
      break;
    case ESC_KEYCODE:
      hidePopupFn();
      $target.focus();
      break;
  }
}

function initAccessibility({ popupId, hidePopup, $targetElement }) {
  const $popup = $(`#${popupId}`);
  if ($popup.find('.countryPickerColumnContainer').length || $popup.find('.navigation-popover').length) {
    return;
  }

  $popupLinks = $popup.find('a:not(.xpop-close)');
  if ($popupLinks.length) {
    $target = $targetElement;
    hidePopupFn = hidePopup;
    $popupLinks.bind('keydown', onKeyDownItem);
    $popupLinks.first().focus();
  }
}

export default initAccessibility;
